export default __webpack_public_path__ + "static/media/footer-logo.221f0413.svg";